import { createStore } from 'vuex';

import dashboard from './dashboard';
import user from './user';
import company from './company';
import companyUser from './companyUser';
import board from './board';
import roles from './roles';
import project from './project';


const store = createStore({
	modules: {
		dashboard,
		user,
        company,
		companyUser,
        board,
		roles,
		project,
	},
	strict: false//process.env.NODE_ENV !== 'production'
});

export default store;